const createUserPayload = (user, role) => ({
  // accountId: `EDU-${user.externalAccountId}`,
  accountId: `EDU-${user.externalAccountId}` || `Vizzle${user.schoolId}`,
  email: user.email,
  firstName: user.firstName,
  lastName: user.lastName,
  id: `VZL-${user.id}`,
  // id: user.id,
  role,
  district: `EDU-${user.externalAccountId}`,
  division: 'Education',
  product: 'Vizzle',
  districtName: user.district,
  school: user.eduIdentifier,
  schoolName: user.schoolName,
  availableComponents: ['Vizzle'],
  accountIntegration: user.accountIntegrationType,
});
const createAccountPayload = (user) => ({
  // id: `EDU-${user.externalAccountId}`,
  id: `EDU-${user.externalAccountId}` || `Vizzle${user.schoolId}`,
  name: user.district,
  state: user.state,
});
export default {
  trackTeacher: (user) => {
    if (!process.env.REACT_APP_GAIN_SIGHT_SERVICE_KEY) {
      return;
    }
    if (!user.isDistrictActive || !user.isDistrictPaidCustomer) {
      return;
    }
    const userPayload = createUserPayload(user, user.userAdmin ? 'Admin' : 'Teacher');
    const accountPayload = createAccountPayload(user);

    /* eslint-disable*/
    console.log('Gainsight User Payload:', userPayload);
    console.log('Gainsight Account Payload:', accountPayload);

    // eslint-disable-next-line no-undef
    aptrinsic('identify', userPayload, accountPayload);
  },

/*  trackStudent: (user) => {
    if (!process.env.REACT_APP_GAIN_SIGHT_SERVICE_KEY) {
      return;
    }
    if (!user.isDistrictActive || !user.isDistrictPaidCustomer) {
      return;
    }
    const userPayload = createUserPayload(user, 'Student');
    userPayload.firstName = undefined;
    userPayload.lastName = undefined;
    const accountPayload = createAccountPayload(user);
    // eslint-disable-next-line no-undef
    aptrinsic('identify', userPayload, accountPayload);
  }, */
};
